export const GETPROTOCOLS = "GETPROTOCOLS";
export const ERRORPROTOCOL = "ERRORPROTOCOL";
export const RESETPROTOCOL = "RESETPROTOCOL";
